"use client";

import Image from "next/image";
import { Icons } from "@/components/icons";
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { serializer } from "@/utils/rich-text-renderer";
import Link from "next/link";

/* interface IntroProps {
  intro: GetHomeQuery;
} */

export default function Outro({ outro }: any) {
  // TODO: Fix type
  const imageRef = useRef<HTMLImageElement>(null);

  /* useGSAP(() => {
    gsap.to(imageRef.current, {
      duration: 1,
      ease: "power4.inOut",
      scrollTrigger: {
        trigger: home.heroImage?.url || "",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
      },
    });
  }); */

  const renderThis = (intro: any) => {
    return !!(
      outro.outroImage?.url ||
      outro.outroTitle ||
      outro.outroText?.raw ||
      outro.outroButton?.link ||
      outro.outroButton?.displayText
    );
  };

  if (renderThis(outro)) {
    return (
      <section className="cs-container overflow-hidden">
        <div className="flex flex-row flex-wrap pt-12 md:pt-24 lg:flex-nowrap lg:items-center">
          <div className="flex w-full flex-col sm:w-6/12">
            <h2 className="mb-12 font-extrabold" dangerouslySetInnerHTML={{ __html: outro.outroTitle }}></h2>
            <RichText
              content={outro.outroText?.raw}
              renderers={{
                h5: ({ children }: any) => (
                  <h5 className="mt-10 text-base font-medium sm:text-lg md:text-xl lg:text-2xl">{children}</h5>
                ),
                p: ({ children }: any) => <p className="text-base-200 text-base leading-relaxed">{children}</p>,
              }}
            />
            {outro.outroButton?.link && outro.outroButton?.displayText && (
              <div className="mr-auto mt-6 inline">
                <Link className="button-long relative" href={outro.outroButton.link}>
                  <div className="strip"></div>
                  {outro.outroButton.displayText}
                </Link>
              </div>
            )}
          </div>
          <div className="mt-10 w-full sm:mt-0 sm:w-6/12">
            <div className="relative flex h-[450px] w-full items-center">
              <Icons.mirrorLine className="absolute left-0 top-0 z-10 h-full w-auto text-primary md:left-3 lg:left-6" />
              <Image
                src={outro.outroImage?.url || ""}
                alt={outro.outroImage?.altText || ""}
                priority
                width={1920}
                height={1080}
                className="ml-5 !h-[374px] !w-[-webkit-fill-available] object-cover md:ml-[30px] md:max-w-[1200px] lg:ml-[43px]"
                style={{ clipPath: "polygon(156px 0%, 100% 0%, 100% 100%, 0% 100%)" }}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
